import axios from "axios";
import { imageAuthSlice, callTypes } from "./imageAuthSlice";

const API_URL = process.env.REACT_APP_API_URL;
const { actions } = imageAuthSlice;

export const fetchVerificationImageToken = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.getVerificationToken }));

  return axios
    .get(API_URL + "media-access/private-token")
    .then((response) => {
      const urlParams = new URL(response.data).search;
      dispatch(
        actions.verificationTokenFetched({ verificationToken: urlParams })
      );
    })
    .catch((err) => {
      dispatch(
        actions.catchError({
          error: err,
          callType: callTypes.getVerificationToken,
        })
      );
    });
};

export const fetchImageToken = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.getImageToken }));

  return axios
    .get(API_URL + "media-access/token")
    .then((response) => {
      const urlParams = new URL(response.data).search;
      dispatch(actions.imageTokenFetched({ imageToken: urlParams }));
    })
    .catch((err) => {
      dispatch(
        actions.catchError({ error: err, callType: callTypes.getImageToken })
      );
    });
};
